import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import clsx from "clsx";
import { AIMContextViewAtom } from "../../panels/AIMPanelContext";
import { useSetAtom } from "jotai";
import { DeltaCalculation } from "./DeltaCalculation";
import { MetricSourceFiles } from "@/features/Metrics/components/MetricSourceFiles";
import { EmptyStateCard } from "../../components/EmptyStateCard";
import { Delta } from "@/features/Metrics/Delta";

export type DeltaLineageProps = {
    delta: Delta;
};

export function DeltaLineagePanel({ delta }: DeltaLineageProps) {
    const setAIMContextView = useSetAtom(AIMContextViewAtom);
    const errorMessage = delta.errorMessage;

    return (
        <div
            className={clsx(
                "px-6 pb-6",
                "custom-scrollbar absolute inset-0 flex min-h-0 flex-col overflow-hidden",
            )}
        >
            <div className="sticky my-4 flex flex-col">
                <RightSidebarButton
                    onClick={() => {
                        setAIMContextView(null);
                    }}
                />
                {delta.metric && (
                    <h2 className="pageheading ">
                        {delta.metric.label} - % Change
                    </h2>
                )}
            </div>
            <div className="custom-scrollbar hide-scrollbar overflow-y-scroll">
                {errorMessage && (
                    <EmptyStateCard
                        heading="Delta not available"
                        body={errorMessage}
                    />
                )}
                {delta.metric && delta.formula && (
                    <div>
                        <h2 className="heading-l mb-4 mt-6">Calculations</h2>
                        <div className="flex flex-col gap-6">
                            <DeltaCalculation
                                calculation={delta.formula.previous}
                                section="previous"
                            />
                            <DeltaCalculation
                                calculation={delta.formula.current}
                                section="current"
                            />
                            <DeltaCalculation
                                calculation={delta.formula.delta}
                                section="delta"
                                highlightElements
                            />
                        </div>

                        <h2 className="heading-l mb-4 mt-7">Sources</h2>
                        <MetricSourceFiles
                            code={delta.metric.code}
                            onSourceSelect={() => {
                                setAIMContextView(null);
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
